'use client';

import { c as _c } from "react/compiler-runtime";
import { useSuspenseQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import { resolveIdentifiedHotDeal } from '../_utils/resolveHotDeal';
export const useAffiliateProductGroups = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...UnauthQueryOptions["get:/wello/v1/allows/affiliate/products"](),
      select: _temp2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useSuspenseQuery(t0);
};
export type AffiliateProductGroup = ReturnType<typeof useAffiliateProductGroups>['data'][number];
function _temp(t0) {
  const {
    hotDealList,
    ...group
  } = t0;
  return {
    ...group,
    hotDealList: hotDealList.flatMap(resolveIdentifiedHotDeal)
  };
}
function _temp2(response) {
  return (response.context?.groups ?? []).map(_temp);
}